<template>
    <div class="mt-2" v-if="simulations">

        <div class="pb-4">
            <base-button type="white mr-1" size="sm" @click="expandAll">
                <i class="fas fa-chevron-down"></i>
                {{ $t('common.expand-all') }}
            </base-button>
            
            <base-button type="white" size="sm" @click="collapseAll">
                <i class="fas fa-chevron-up"></i>
                {{ $t('common.collapse-all') }}
            </base-button>
        </div>

        <div ref="simulations">
            <collapse class="simulations pb-3" ref="simulations-collapse">

                <div v-for="(simulation, index) in simulations" :key="index">

                    <collapse-item-card :id="'simulation-'+index" :active-default="true" :show-default="false">

                        <template slot="title">
                            <div class="row align-items-center pl-4">
                                <div class="col" style="flex: 0 0 80px">
                                    <h5 class="mb-0 float-left" style="font-size:1.1rem;font-weight:700">
                                        {{ simulation.name }}
                                    </h5>
                                </div>
                                <div class="col text-right" style="flex: 0 0 160px">
                                </div>
                            </div>
<!--
                            <h5 class="mb-0 float-left" style="font-size:1.1rem;font-weight:700">
                                {{ simulation.name }}
                            </h5>
-->
                        </template>

                        <template>
                            <issues
                                :registration="registration"
                                :simulation="simulation"
                                :role="role"
                                scope="all"
                                @loaded="issuesLoaded(index, $event)"
                            >
                            </issues>
                        </template>

                    </collapse-item-card>
                </div>
            </collapse>
        </div>
    </div>
</template>

<script>
    import Issues from '../session/Issues'

    export default {

        components: {
            Issues
        },

        props: {
            
            registration: {
                type: Object,
                required: true
            },
            
            simulations: {
                type: Array,
                required: true
            },
            
            role: {
                type: String,
                required: true
            },
        },

        data() {
            return {
            }
        },


        methods: {

            issuesLoaded(index, number) {
                if (number != 0) {
                    this.$refs['simulations-collapse'].showItem('simulation-'+index)
                }
            },

            expandAll() {
                this.$refs['simulations-collapse'].expandAll();
            },

            collapseAll() {
                this.$refs['simulations-collapse'].collapseAll();
            },
        }
    }
</script>

<style scoped>

    .simulations >>> .card-header:after {
        right: auto;
    }
    .simulations >>> .card-body {
        padding: 0;
    }

</style>
